<template>
  <v-app-bar color="white" class="shadow" height="66" max-height="66" fixed style="background: #f8f8f8!important">
    <div class="container" style="max-width: 900px;">
      <v-row>
        <v-col cols="12" md="9" class="d-flex align-center position-relative">
          <router-link to="/">
            <img src="https://creditclan.com/images/logo-small.png" alt="cc logo" style="width: 130px"/>
          </router-link>
          <v-spacer></v-spacer>
          <div class="white rounded-xl" style="max-width: 260px;">
            <v-text-field
              v-model="query" @click:append="$emit('search', query)" @keyup.enter="$emit('search', query)"
              :hide-details="'auto'" append-icon="mdi-magnify" placeholder="Search.." dense filled rounded
            ></v-text-field>
          </div>
          <v-spacer></v-spacer>
          <v-btn @click="$store.dispatch('cart/show')" color="black" icon>
            <v-badge :content="`${$store.state.cart.items.length}`" color="red" overlap>
              <v-icon>mdi-cart-outline</v-icon>
            </v-badge>
          </v-btn>
        </v-col>
      </v-row>
    </div>
  </v-app-bar>
</template>

<script>
export default {
  name: "ResultsNav",
  props: {
    initialValue: {
      type: String,
      required: true
    }
  },
  created() {
    this.query = this.initialValue;
  },
  data() {
    return {
      query: ''
    }
  },
  watch: {
    initialValue(v) {
      this.query = v;
    }
  }
}
</script>
